import { baseUrl } from './routes';

export class VendorRoutes {
  static get vendors(): string {
    return `${baseUrl}/vendors`;
  }

  static get add(): string {
    return `${baseUrl}/vendors/add`;
  }

  static get edit(): string {
    return `${baseUrl}/vendors/edit`;
  }
}
